'use client';

import { useEffect } from 'react';
import { tokenStore } from '@/@shared/middleware/tokenStore';
import { useRouter } from '@/i18n/routing';

export default function RootRedirect() {
	const router = useRouter();

	useEffect(() => {
		const hasToken = Boolean(tokenStore.getAccessToken());
		router.replace(hasToken ? '/home' : '/signin');
	}, [router]);

	return null;
}
